import React from "react";
import PropTypes from "prop-types";
import { withTheme } from "styled-components";

export const AddIcon = ({ theme }) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M20 13.143H13.1426V20H10.8574V13.143H4V10.857H10.8574V4H13.1426V10.857H20V13.143Z"
      fill={theme.borderColorDisabled}
    />
    <circle cx="12" cy="12" r="11.5" stroke={theme.borderColorDisabled} />
  </svg>
);

AddIcon.propTypes = {
  theme: PropTypes.shape({ errorColor: PropTypes.string }).isRequired
};

export default withTheme(AddIcon);
